module.exports = __webpack_public_path__ + "static/media/as.13c3700c.svg";